import React from "react";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import useResize from "../../hooks/resize";
export default function ListView({
  style,
  swiper = true,
  direction = "vertical",
  elements,
  listData,
  slidesPerView = 4,
  spaceBetween = 2,
  title,
  subTitle,
  action,
  devices,
}) {
  const media = useResize();
  return (
    <div
      className="listview_wraper"
      style={{ position: "relative", ...style.root }}>
      <div className="listview_header" style={{ ...style.header }}>
        {title ? <h2 style={{ ...style.title }}>{title}</h2> : undefined}
        {subTitle ? (
          <h4 style={{ ...style.subTitle }}>{subTitle}</h4>
        ) : undefined}
        {action
          ? React.cloneElement(action, { style: style.action })
          : undefined}
      </div>
      {swiper ? (
        <Swiper
          style={{ ...style.scrollContent }}
          spaceBetween={spaceBetween}
          slidesPerView={devices ? devices[media] : slidesPerView}
          modules={Pagination}
          direction={direction === "horizontal" ? "horizontal" : "vertical"}>
          {elements(listData).map((element) => (
            <SwiperSlide>{element}</SwiperSlide>
          ))}
        </Swiper>
      ) : undefined}
    </div>
  );
}
